// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

interface LocalMsalAdapter {
  instance: {
    logoutPopup: (options?: { postLogoutRedirectUri?: string }) => Promise<void>;
  };
}

export const useMsal = (): LocalMsalAdapter => ({
  instance: {
    // Unlike the real @azure/msal-react logoutPopup (which opens a popup and does
    // not navigate the main window), this mock performs the full-page redirect
    // itself. Callers of handleLogout rely on that and must not navigate again
    // afterward. If this is ever swapped for the real MSAL library, callers will
    // need their own post-logout navigation instead.
    logoutPopup: async (_options?: { postLogoutRedirectUri?: string }): Promise<void> => {
      window.location.href = '/api/sso/logout';
    }
  }
});
